import React from 'react';
import clsx from 'clsx';
import { ConfirmButton, ServiceDialog } from '../../../styling/Styles';

const EditListItemsPerPagePopUp = (props) => {

    const {
        editor,
        openNumberOfListItemsPopUp,
        setOpenNumberOfListItemsPopUp,
        componentId
    } = props;

    const [numberPerPage, setNumberPerPage] = React.useState(1);

    const closePopUp = () => {
        setOpenNumberOfListItemsPopUp(false)
    }

    const setListItemsPerPage = () => {
        
        const domComponents = editor.DomComponents;
        const listPaginationComp = domComponents.componentsById[componentId];        
        const listRowContent = 
        `<tr class="list-item-content flex">
            <td class="list-cell-left">
            <img listimage=true alt="Image" src="" href="" class="list-item-image"/>
            </td>
            <td class="list-cell-right ">
            <h1 listtitle=true class="card-title">Title here
            </h1>
            <p listdescription=true class="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
            </p>
            </td>
        </tr>`

        let tBodyContent = '';

        for(let i = 0;i< numberPerPage;i+=1){
            tBodyContent += listRowContent;
        }

        const tableContent = 
        `<table wabliname="list" wablitype="list" ><tbody>${tBodyContent}</tbody></table>
            <nav aria-label="Page navigation example">
            <ul class="pagination" pagination-list=true>
            <li class="page-item" pagination-previous=true><a class="page-link" href="#">Previous</a></li>
            <li class="page-item"><a class="page-link" href="#">1</a></li>
            <li class="page-item"><a class="page-link" href="#">2</a></li>
            <li class="page-item"><a class="page-link" href="#">3</a></li>
            <li class="page-item" pagination-next=true><a class="page-link" href="#">Next</a></li>
            </ul>
        </nav>`;

        listPaginationComp.components(tableContent);
        setOpenNumberOfListItemsPopUp(false);
        setNumberPerPage(1);
    }


    return(
        <ServiceDialog
            open={openNumberOfListItemsPopUp}
            keepMounted
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
        > 
            <div className={clsx('titlePopUp','paddingTitle')}> 
                <span>Edit number of list items per page</span>
                <div onClick={closePopUp} className={clsx('pop-up-close-btn')} aria-hidden="true">x</div>
            </div>
            <div className ='paddingTitle'>
                    <div className={clsx('spacingTopDiv')} style={{display: 'flex', justifyContent: 'center'}}>
                        Please give number of list items per page: &nbsp;&nbsp;
                        <input style={{border: 'solid', borderRadius: '4px', width: '3rem', borderColor: '#0C4D82'}} type="number" value={numberPerPage} min="1" onChange={(e) => setNumberPerPage(e.target.value)}/>
                    </div>
                
                <div  
                    style={{
                        justifyContent:'space-between',
                        display: 'flex',
                        flexDirection: 'row', 
                        marginTop: '2vw',
                    }}

                > 
                    <span>&nbsp;</span>   
                    <ConfirmButton id='confirmButtonPopUp' onClick={setListItemsPerPage}>
                        Confirm
                    </ConfirmButton>
                </div>
            </div>

        </ServiceDialog>
    )

}

export default EditListItemsPerPagePopUp;